import { render, staticRenderFns } from "./ExcutiveDetailComp.vue?vue&type=template&id=0b1f658c&scoped=true"
import script from "./ExcutiveDetailComp.vue?vue&type=script&lang=js"
export * from "./ExcutiveDetailComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1f658c",
  null
  
)

export default component.exports